<template>
  <div class="gameplan">
    <ContentHeader path-set-type="append" :gameplan-nav="false" />
    <div class="content-wrapper">
      <!-- 新建活动 -->
      <div class="activity_new" v-loading="loading">
        <div class="normal_title">活动信息</div>
        <div class="normal_box is-hover-shadow">
          <div class="pr_item">
            <div class="pr_item_left">
              <div class="pr_title">
                活动名称：{{themeBasic.themeName}}
              </div>
              <div class="pr_info">
                <span class="pr_info_type_city">品牌：{{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.brandName}} &nbsp;&nbsp;&nbsp; 子品牌：{{themeBasic.gpPrDTO&&themeBasic.gpPrDTO.subBrandName}}</span>
              </div>
              <div class="pr_info" v-if="this.themeBasic.themeChannels&&this.themeBasic.themeChannels.length>0">
                <span>活动渠道：{{getChannelName()}}</span>
              </div>
              <div class="pr_date">活动执行时间：{{themeBasic.themeStartTime | parseTime("{y}-{m}-{d}")}} - {{themeBasic.themeEndTime | parseTime("{y}-{m}-{d}")}} &nbsp;&nbsp;&nbsp;活动提报时间：{{themeBasic.applyStartTime | parseTime("{y}-{m}-{d}")}} - {{themeBasic.applyEndTime | parseTime("{y}-{m}-{d}")}}</div>
            </div>
            <div class="pr_item_right">
              <div class="pr_status">待配置</div>
            </div>
          </div>
          <!-- <div class="item_detail" v-if="employeeLevel>=60&&employeeLevel<90">区域额度配置：
            <el-radio v-model="buToCity" :label="0">按region分配</el-radio>
            <el-radio v-model="buToCity" :label="1">按city分配</el-radio>
          </div> -->
        </div>
        <div  v-for="(detail,index) of detailList" :key="detail[0].themeDetail.themeStyleCode">
          <ConfigItem  @handleSubmit="handleSubmit" :buToCity="buToCity" :assignAreaList="assignAreaList" :assignRegionList="assignRegionList"
            :igniteOptions="igniteOptions" :themeStyleName="themeStyleName[index]" :themeStyle="detail" :detailListLength="detailListLength"
            :channelName="themeBasic.themeChannels[index].themeChannelEnName" ref="configItemRef" :assignList="assignList"></ConfigItem>
        </div>
      </div>
      <div class="btn_section">
        <div class="normal_btn btn_bg_white" v-if="assignRegionList.length!==0" @click="handleOperation('save')">保存草稿</div>
        <div class="normal_btn btn_bg_white_disadled" v-else>保存草稿</div>
        <div class="normal_btn btn_bg_red" v-if="assignRegionList.length!==0" @click="handleOperation('submit')">提交</div>
        <div class="normal_btn btn_bg_red_disabled" v-else>提交</div>
      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="showConfirmDialog"
      width="30%" >
      <span>是否要{{operateType==='submit'?'提交':'保存'}}当前数据？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showConfirmDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import gameplanApi from "@/api/gameplan";
import { mapGetters } from 'vuex'
import ContentHeader from "@/components/content-header";
import ConfigItem from './components/config-item.vue'
export default {
  components: {
    ContentHeader,
    ConfigItem
  },
  data() {
    return {
      loading:false,
      employeeLevel: '',
      themeTime: [],
      applyTime: [],
      fullConfig: [],
      info:'',
      editRules: {
        themeName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        themeChannelNames: [
          { required: true, message: "请输入选择活动渠道", trigger: "blur" },
        ],
      },
      themeChannelForm: [],
      themeChannelCodes: [],
      themeChannelNames: [],
      detailList: [],
      igniteOptions: {},
      themeBasic: {
        applyEndTime: "2022-10-10T16:00:00.000Z",
        applyStartTime: "2022-09-30T16:00:00.000Z",
        execTemplateId: "222",
        manualFileId: "111",
        prNumber: "C2022",
        themeChannelCodes: ["01"],
        themeEndTime: "2022-10-10T16:00:00.000Z",
        themeName: "",
        themeStartTime: "",
      },
      themeStyleName:[],
      activeName:'',
      assignAreaList:[],
      assignRegionList:[],
      submitList:[],
      detailListLength:0,
      buToCity:0,
      submitDetailList:[],
      assignList:[],
      themeInfo:{},
      isSubmit:false,
      showConfirmDialog:false,
      operateType:'',
      valid:true
      //themeChannelNames:
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch:{
    'buToCity'(val){
      if(this.employeeLevel>=60&&this.employeeLevel<90){
        this.assignList=[]
        if(val===1){
          let itemIndex = []
          let count = 0
          for(let item of this.assignAreaList){
            let index = itemIndex.indexOf(item.parentOrgId)
            if(index===-1){
              for(let parent of this.assignRegionList){
                if(item.parentOrgId===parent.orgId){
                  item.parentOrgName = parent.orgName
                  item.parentOrgCode = parent.orgCode
                  let data = [item]
                  this.assignList.splice(this.assignList.length,0,data)
                  itemIndex.push(item.parentOrgId)
                }
              }
            }else {
              item.parentOrgCode = this.assignList[index][0].parentOrgCode
              this.assignList[index].splice(this.assignList.length,0,item)
            }
          }
        }else {
          this.assignList=this.assignRegionList
        }
      }
    }
  },
  created() {
    this.getGameplanConfigFull()
    this.employeeLevel = this.userInfo.employeeLevel
    this.getGameplanConfigIgniteOptions()
    this.themeId = this.$route.query.themeId
  },
  methods: {
    async getGameplanThemeInfo() {
      this.loading = true
      let params = {
        themeId:this.$route.query.themeId
      }
      const { data } = await gameplanApi.getGameplanThemeInfo(params);
      if (data.resultCode === "0") {
        this.themeBasic = data.resultData?.themeInfo.themeBasic || []
        this.detailListLength = data.resultData.themeInfo.detailList.length
        let list = data.resultData?.themeInfo.detailList || [];
        this.themeId  = this.themeBasic
        // 按照相同的渠道拆分为detailList[]
        if(this.employeeLevel>=60&&this.employeeLevel<90){
          this.buToCity = this.themeBasic.buToCity
        }
        for(let i = 0;i<list.length;i++){
          let item  = list[i]
          if(item.curAssignList&&item.curAssignList.length>0){
            let index = this.themeChannelCodes.indexOf(item.themeDetail.themeChannelCode)
            if(index!==-1){
              this.detailList[index].push(item)
              if(this.themeStyleName[index].indexOf(item.themeDetail.themeStyleName)===-1){
                this.themeStyleName[index].push(item.themeDetail.themeStyleName)
              }
            }else{
              this.themeChannelCodes.push(item.themeDetail.themeChannelCode)
              let data = [item]
              let item_themeStyleName = [item.themeDetail.themeStyleName]
              this.detailList.push(data)
              this.themeStyleName.push(item_themeStyleName)
            }
          }
        }
        this.loading = false
      }
    },
    async getGameplanConfigIgniteOptions() {
      const { data } = await gameplanApi.getGameplanConfigIgniteOptions();
      if (data.resultCode === "0") {
        this.igniteOptions = data.resultData?.igniteOptions || {};
      }
    },
    async getGameplanConfigFull() {
      const { data } = await gameplanApi.getGameplanConfigFull();
      if (data.resultCode === "0") {
        this.assignAreaList = data.resultData?.assignAreaList || []
        this.assignRegionList = data.resultData?.assignRegionList || []
        if(this.employeeLevel<60&&this.employeeLevel>=45){
          this.buToCity = 0
          this.assignList = this.assignAreaList // Object.assign({},this.assignAreaList) 
        }
      }
      this.getGameplanThemeInfo()
    },
    handleOperation(type){
      //this.showConfirmDialog=true
      this.operateType = type
      this.$confirm(`是否要${this.operateType==='submit'?'提交':'保存'}当前数据？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'btn-red',
          type: 'warning'
        }).then(async() => {
          this.submit()
        }).catch(() => {
        });
    },
    submit() {
      this.valid = true
      this.showConfirmDialog=false
      this.submitList = []
      if(this.$refs.configItemRef&&this.$refs.configItemRef.length>0){
        for(let i=0;i<this.$refs.configItemRef.length;i++){
          this.$refs.configItemRef[i].submit(this.operateType)
        }
      }
      this.themeBasic.buToCity = this.buToCity
      let data = {
        detailList:this.submitList,
        themeBasic:this.themeBasic
      }
      console.log(this.valid);
      if(this.valid){
        this.operateType ==='save'?this.getGameplanThemeSave(data):this.handleGetGameplanThemeSubmit(data)
      }else {
        this.$alert('提交错误，请检查数据后再提交！', '提示', {
          confirmButtonText: '确定',
          callback: () => {
          }
        });
      }
      //console.log(JSON.stringify(data));
    },
    handleGetGameplanThemeSubmit(data){
      this.getGameplanThemeSubmit(data)
    },
    async getGameplanThemeSubmit(data) {
      this.loading = true
      console.log(data);
      const res = await gameplanApi.getGameplanThemeSubmit(data);
      if (res.data.resultCode === "0") {
        this.$message.success("提交成功！")
        this.$router.go(-1)
        //this.$router.push({path:'/gameplan/activity-management'})
      }
      this.loading = false
    },
    async getGameplanThemeSave(data) {
      this.loading = true
      console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSave(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
      }
      this.loading = false
    },
    async getGameplanThemeSaveUpdate(data) {
      this.loading = true
      console.log(data);
      const  res  = await gameplanApi.getGameplanThemeSaveUpdate(data);
      if (res.data.resultCode === "0") {
        this.$message.success("保存成功！")
        this.$router.go(-1)
        //this.$router.push({path:'/gameplan/activity-management'})
      }
      this.loading = false
    },
    handleSubmit(detailItem,valid) {
      if(!valid){
        this.valid = false
      }
      this.submitList.push(detailItem)
    },
    getChannelName(){
      let result = ''
      for(let item of this.themeBasic.themeChannels){
        result += item.themeChannelEnName+'、'
      }
      return result.substr(0, result.length - 1); 
    }
  },
}
</script>
<style lang="scss" scoped>
::v-deep.el-radio {
  margin-right: 60px;

  .el-radio__input {
    display: inline-block;
    padding-right: 5px;

    &.is-checked .el-radio__inner {
      border-color: $base-red;
      background: $base-red;
    }

    &.is-checked+.el-radio__label {
      color: #101010;
    }
  }
}

::v-deep .activity_new .el-form-item {
  min-width: 48%;
  margin-bottom: 12px;

  .el-form-item__label {
    color: black;
  }
}

.content-wrapper {
  margin-top: -50px;

  .activity_new {
    position: relative;

    .activity-new-card {
      padding: 20px 10px 20px 0px;
      background-color: #ffffff;
      color: #101010;
      border-radius: 10px;
      font-size: 16px;
      text-align: left;
      font-family: SourceHanSansSC-bold;
      display: flex;
      justify-content: flex-start;

      .po_config_btn {
        position: absolute;
        right: 0;
        top: -25px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #539efe;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        font-family: Roboto;
      }
    }

    .activity_channel_checkbox {
      margin-top: 0px;
    }

    .activity_channel_checkbox_label {
      text-align: center;
      position: relative;
      top: 15px;
      line-height: 15px;
    }
  }
}

.pr_info{
  margin: 5px 0;
}

.activity_form{
  margin: 0px 0 30px 40px;
  font-weight: 600;
  font-size: 15px;
  height: 30px;
}
.activity_form_detail{
  margin-left: 100px;
}
.activity_form_box{
  margin-bottom:20px;
  height: 25px;
}

.tab_box {
  margin-top: 20px;

  .tab_item_box {
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-top-right-radius: 8px;

    .tab_item_context {
      height: 100%;
      width: calc(100% - 40px);
      padding: 20px;
      font-size: 15px;
    }
  }
}
.item_title{
  display: inline-block;
  width: 200px;
  font-weight: 600;
}
.item_detail{
  margin: 20px 5px ;
}


.btn_section {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  text-align: center;
  margin-top: 60px;

  .normal_btn {
    width: 100px;
    padding: 10px 0;
    border-radius: 5px;
    cursor: pointer;
  }

  .btn_bg_white {
    border: 1px solid rgb(204, 0, 0);
    color: rgb(204, 0, 0);
    margin-right: 100px;
  }

  .btn_bg_red {
    color: white;
    background-color: rgb(204, 0, 0);
    border: 1px solid rgb(204, 0, 0);
  }
}
.btn_bg_red_disabled{
    color: white;
    cursor: no-drop !important;
    background-color: $base-grey4 !important;
    border: 1px solid $base-grey4 !important;
  }
.btn_bg_white_disadled{
  border: 1px solid $base-grey4 !important;
  color: $base-grey4 !important;
  cursor: no-drop !important;
  margin-right: 100px;
}
</style>